export default __webpack_public_path__ + "static/media/BriefcaseIcon.04c73cea.svg";